
import { useEffect } from 'react';
 import { getRateByCurrencyCode } from '@store/Finance/DailyRates/DailyRatesSlice';
import { useAppDispatch, useAppSelector } from '@store/hooks';

interface UseDailyRateParams {
  currencyCode: string;
  date: string;
  autoFetch?: boolean; // للتحكم إن كنت تريد الجلب مباشرة أم يدويًا
}

export const useDailyRate = ({ currencyCode, date, autoFetch = true }: UseDailyRateParams) => {
  const dispatch = useAppDispatch();
  const rate = useAppSelector((state) => state.DailyRates.rate);
  const loading = useAppSelector((state) => state.DailyRates.loadingRate);
  const error = useAppSelector((state) => state.DailyRates.errorRate);

  useEffect(() => {
    if (autoFetch && currencyCode) {
      dispatch(getRateByCurrencyCode({ CurrencyCode: currencyCode, date }));
    }
  }, [dispatch, currencyCode, date, autoFetch]);

  // نعيد كل ما نحتاجه
  return { rate, loading, error, refetch: () => dispatch(getRateByCurrencyCode({ CurrencyCode: currencyCode, date })) };
};
